module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/lightTank.6be7b229.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/lightTank.png
// module id = 2724
// module chunks = 11